module.exports = __webpack_public_path__ + "static/media/gryphon-house-lobby-widecrop.7abe59db.jpg";